import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import Counter from "../../Tool/Counter/Counter";
import "./Timer.scss";
import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../../../utils/Utils";

class SideMargin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: this.props.content,
      date: new Date(),
      moreOptionsVal: false,
    };
  }

  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  render() {
    return (
      <>
        <div style={{display:'flex',flexDirection:"row"}} className="modalContentWrapper">
          <div className="d-block">
            <Counter
              label="Top"
              small={this.props.timerMarginUnit === "%" ? "percent" : "pixel"}
              minusClick={() =>
                this.counterMinus(this.props.marginTop, "marginTop")
              }
              valueContent={this.props.marginTop}
              disabled={false}
              onChange={(e) => {
                this.counterChange(e, "marginTop");
              }}
              plusClick={() =>
                this.counterPlus(this.props.marginTop, "marginTop")
              }
            />
          </div>
          <div className="d-block">
            <Counter
              label="Bottom"
              small={this.props.timerMarginUnit === "%" ? "percent" : "pixel"}
              minusClick={() =>
                this.counterMinus(this.props.marginBottom, "marginBottom")
              }
              valueContent={this.props.marginBottom}
              disabled={false}
              onChange={(e) => {
                this.counterChange(e, "marginBottom");
              }}
              plusClick={() =>
                this.counterPlus(this.props.marginBottom, "marginBottom")
              }
            />
          </div>
          <div className="d-block">
            <Counter
              label="Left"
              small={this.props.timerMarginUnit === "%" ? "percent" : "pixel"}
              minusClick={() =>
                this.counterMinus(this.props.marginLeft, "marginLeft")
              }
              valueContent={this.props.marginLeft}
              disabled={false}
              onChange={(e) => {
                this.counterChange(e, "marginLeft");
              }}
              plusClick={() =>
                this.counterPlus(this.props.marginLeft, "marginLeft")
              }
            />
          </div>
          <div className="d-block">
            <Counter
              label="Right"
              small={this.props.timerMarginUnit === "%" ? "percent" : "pixel"}
              minusClick={() =>
                this.counterMinus(this.props.marginRight, "marginRight")
              }
              valueContent={this.props.marginRight}
              disabled={false}
              onChange={(e) => {
                this.counterChange(e, "marginRight");
              }}
              plusClick={() =>
                this.counterPlus(this.props.marginRight, "marginRight")
              }
            />
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SideMargin);
